export const sortParams = (sorter) => {
  const active = (Array.isArray(sorter) ? sorter : [sorter]).find(item => item?.order);
  return active ? { sortField: active.field, sortOrder: active.order === "descend" ? "desc" : "asc" } : {};
};

export const buildSavePayload = (values, files, type, id, attachmentsLoaded) => {
  if (type === "edit" && !attachmentsLoaded) throw new Error("Existing attachments must finish loading before saving.");
  return {
    ...values,
    vendorPendingCheckId: type === "edit" ? id : undefined,
    invoiceDate: values.invoiceDate?.format("YYYY-MM-DD") || "",
    tenantId: 0,
    fileList: files.filter(file => !file.fileUploadId),
    retainedFileIds: type === "edit" ? files.filter(file => file.fileUploadId).map(file => file.fileUploadId) : undefined,
  };
};

export const validateAmount = (_, value) => {
  const amount = Number(value);
  return value != null && value !== "" && Number.isFinite(amount) && amount >= 0.01 && amount <= 100000000
    ? Promise.resolve()
    : Promise.reject(new Error("Amount must be between 0.01 and 100000000."));
};
